/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true  }] */
import { REST_URI } from 'lib/appConfig';
import { SocketChannel } from './SocketChannel';

const event = {
  CHANNEL_UPDATE: 'channel_update',
  JOIN_FAILURE: 'channel_join_failure',
  CHANNEL_ERROR: 'channel_error',
};

const ENDPOINT = `${REST_URI}/events/firstarticleinspection`;

class FAISocket {
  constructor({ companyId, machineRef, workOrderOperationRef }) {
    this.socket = new SocketChannel({
      url: ENDPOINT,
      joinParams: { companyId, machineRef, workOrderOperationRef },
    });
    this._onUpdate = null;
    this._onFailure = null;
  }

  subscribe(onData, onFailure) {
    this._onUpdate = onData;
    this._onFailure = onFailure || null;

    this.socket.on(event.CHANNEL_UPDATE, this._onUpdate);

    if (this._onFailure) {
      this.socket.on(event.JOIN_FAILURE, this._onFailure);
      this.socket.on(event.CHANNEL_ERROR, this._onFailure);
    }
  }

  leave() {
    if (this._onUpdate) {
      this.socket.off(event.CHANNEL_UPDATE, this._onUpdate);
    }
    if (this._onFailure) {
      this.socket.off(event.JOIN_FAILURE, this._onFailure);
      this.socket.off(event.CHANNEL_ERROR, this._onFailure);
    }
    this.socket.disconnect();
  }
}

export { FAISocket };
